const Step3 = () => {
  return <h1>Step 3</h1>;
};

export default Step3;
